"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsSize = void 0;
var _GlobalSize = _interopRequireDefault(require("../type-tools/GlobalSize"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var TabsSize = exports.TabsSize = function (TabsSize) {
  TabsSize[TabsSize["MEDIUM"] = _GlobalSize["default"].MEDIUM] = "MEDIUM";
  TabsSize[TabsSize["LARGE"] = _GlobalSize["default"].LARGE] = "LARGE";
  return TabsSize;
}(TabsSize || {});